import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import axios from '../axiosConfig';
import {
  bookTripFailure, resetTripAvailabilityPriceStatus, tripPriceCheckRequest, tripPriceCheckResponse,
} from '../../slices/trip';

const queryString = require('query-string');

function* tripPriceCheckWorker({
  payload: {
    tripId,
    doReturnAvailabilityError,
    doReturnPriceChangeError,
  },
}) {
  try {
    yield put(resetTripAvailabilityPriceStatus());
    const request = { tripId };
    if (doReturnAvailabilityError) {
      request.doReturnAvailabilityError = true;
    }
    if (doReturnPriceChangeError) {
      request.doReturnPriceChangeError = true;
    }

    const url = `/trips/priceCheck?${queryString.stringify(request, { skipNull: true })}`;
    const config = {
      method: 'get',
      url,
    };
    yield call(axios, config);
  } catch (error) {
    if (error.response.status === 406) {
      // Trip updated exception (from api it will return NotAcceptable response status)
      yield put(bookTripFailure({
        error: 'Your trip availability/price is changed!',
        isTripAvailabilityPriceChanged: true,
        tripAvailabilityPriceChangeResponse: error.response.data,
      }));
    }
  } finally {
    yield put(tripPriceCheckResponse());
  }
}

function* getTripWatcher() {
  yield takeLatest(tripPriceCheckRequest.toString(), tripPriceCheckWorker);
}

export default getTripWatcher;
